import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import classNames from 'classnames';
import { getDD, getListByDD } from 'y4/Y4Api';
import y, { getQueries, setQueriesOther } from 'y4/Utils';
import { run as runCommand } from '../Executer';
import _ from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BasicCard from './BasicCard';
import BasicList from './BasicList';

/** Load all data from back end for DataPanel
 * @param {*} panel Data panel of Y4
 * @param {*} withDd false: Without Data defination
 * @param {*} queries
 * @returns
 */
async function loadData(form, panel, withDd = true, queries = {}) {
  const dataCode = panel.dataCode;

  /*
  const buttonClick = (e, rows) => {
    if (panel.buttonClick) panel.buttonClick(e, rows);
  };
  */

  //Get data definition
  let rt_dd = null;
  if (withDd) {
    rt_dd = await getDD(dataCode, queries);
    if (rt_dd.isNotOk()) return { rt: rt_dd };
  }

  //Set queries other field
  setQueriesOther(form, queries);

  //Get all list and statistics by data definitioin
  const rt_data = await getListByDD(dataCode, {
    count: -1,
    statistics: 'false',
    ...queries
  });
  if (rt_data.isNotOk()) return { rt: rt_data };

  //Return async data
  return {
    rt: rt_data, //last rt
    filters: rt_dd && rt_dd.data.queries,
    rows: rt_data.data.list //rows
  };
}

/**
 *
 * @param {*} panel
 * @returns
 */
const BasicListPanel = ({ form, panel }) => {
  const { t } = useTranslation('data');

  const navigate = useNavigate();

  const location = useLocation();
  var queries = getQueries(location.search);

  //Data to show by state
  const [data, setData] = useState({
    error: 1,
    errorTitle: t('Loading....'),
    errorDescription: t('Data is still loading, please wait')
  });

  //Load data after UI shown
  useEffect(() => {
    //Default filters
    const dfs = _.get(panel, 'option.defaultFilters', {});
    setFilter(dfs);

    const all_filter = { ...dfs, ...queries };
    //Load data from back end
    loadData(form, panel, true, all_filter).then(
      ({ rt, filters, columns, rows, statistics }) => {
        if (rt.isOk()) {
          panel.loadedColumns = columns;
          panel.loadedFilters = filters;
          setDataAndDispatch({ columns, rows, statistics, filters });
        } else {
          setData({
            error: 1,
            errorTitle: `Error ${rt.id}` + (rt.code ? `(${rt.code})` : ''),
            errorDescription: rt.message
          });
        }
      }
    );
  }, []);

  //Search data
  const [filter, setFilter] = useState();
  const search = fs => {
    setFilter(fs);
    loadData(form, panel, false, fs).then(({ rt, rows, statistics }) => {
      if (rt.isOk()) {
        panel.currentFilters = fs;
        setDataAndDispatch({
          columns: panel.loadedColumns,
          filters: panel.loadedFilters,
          rows,
          statistics
        });
      } else {
        setData({
          error: 1,
          errorTitle: `Error ${rt.id}` + (rt.code ? `(${rt.code})` : ''),
          errorDescription: rt.message
        });
      }
    });
  };

  //Buttons click
  const buttonClick = (button, rows) => {
    runCommand({
      form,
      panel,
      command: button.command,
      params: button.params,
      dataCode: panel.dataCode,
      successMessage: button.successMessage,
      successCommand: button.successCommand,
      navigate: navigate,
      rows: rows,
      filter: filter,
      queries: queries
    });
  };

  //Row button click to use this function
  panel.buttonClick = buttonClick;

  //Dispatch afterPanelLoaded;
  const setDataAndDispatch = d => {
    form.eventTarget.dispatchEvent(
      new CustomEvent('form-event', {
        detail: {
          event: 'afterDataLoaded',
          panel,
          form,
          data: d
        }
      })
    );
    if (y.isEmpty(d.rows)) {
      setData({
        error: 1,
        errorTitle: y.gpv(panel, 'option.empty.title'),
        errorDescription: y.gpv(panel, 'option.empty.description')
      });
    } else {
      setData(d);
    }
    form.eventTarget.dispatchEvent(
      new CustomEvent('form-event', {
        detail: {
          event: 'afterPanelLoaded',
          panel,
          form,
          data: d
        }
      })
    );
  };

  //Listen events
  useEffect(() => {
    form.eventTarget.addEventListener('form-event', e => {
      const event = e.detail.event;
      const path = 'events.listen' + y.firstCharToUpper(event);
      const script = y.gpv(panel, path);
      if (script) {
        const f = Function('y', 'source', 'target', script);
        f(y, e.detail, {
          form,
          panel,
          data,
          setData,
          setDataAndDispatch,
          search
        });
      }
    });
  }, [form.eventTarget]);

  const layout = y.gpv(panel, 'option.layout');
  const isList = layout != 'card';

  return (
    data &&
    (data.error ? (
      <>
        <h5 className="mb-0 mt-1">{data.errorTitle}</h5>
        <div className="pt-3">{data.errorDescription}</div>
      </>
    ) : (
      <Row
        className={classNames({
          'g-0': isList
        })}
      >
        {data.rows.map((item, index) =>
          isList ? (
            <BasicList
              key={index}
              index={index}
              form={form}
              panel={panel}
              data={item}
            ></BasicList>
          ) : (
            <BasicCard
              key={index}
              index={index}
              form={form}
              panel={panel}
              data={item}
              md={6}
              lg={4}
            ></BasicCard>
          )
        )}
      </Row>
    ))
  );
};

BasicListPanel.propTypes = {
  form: PropTypes.object,
  panel: PropTypes.object
};

export default BasicListPanel;
